module.exports = __webpack_public_path__ + "img/icon-star-active.867d2d2a.png";